module.exports = __webpack_public_path__ + "img/honour.83f5d981.png";